// Import model
import { FilterPromptRequest } from '../models/FilterPromptRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { PromptCondition } from '../models/PromptCondition';
import { PromptFields } from '../models/PromptFields';
import { PromptIndexedFields } from '../models/PromptIndexedFields';

// Import dependency serializers (for complex types)
import { PromptConditionSerializer } from './PromptConditionSerializer';
import { PromptFieldsSerializer } from './PromptFieldsSerializer';
import { PromptIndexedFieldsSerializer } from './PromptIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterPromptRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterPromptRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterPromptRequest instance
   */
  static deserialize(json: string): FilterPromptRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterPromptRequest instance
   */
  static fromObject(obj: any): FilterPromptRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterPromptRequest');
    }


    const instance: FilterPromptRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as PromptIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as PromptFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        PromptConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterPromptRequest instances
   */
  static deserializeArray(json: string): FilterPromptRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterPromptRequest instance to a JSON string
   */
  static serialize(instance: FilterPromptRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterPromptRequest instance to a plain object
   */
  static toObject(instance: FilterPromptRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        PromptConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterPromptRequest instances to a JSON string
   */
  static serializeArray(instances: FilterPromptRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
